/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { Card, Grid, Header, SidebarLayout } from '@scuf/common';
import PropTypes from 'prop-types';
import AppFooter from '@keystone/common';

/**
 * Class that renders the standard header and footer, plus sets up a grid to
 * center the SLA children components.
 */
class SLAContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { children } = this.props;
    return (
      <>
        <Header title="Honeywell Voice -- Software License Agreement" menu={false} />
        <SidebarLayout className="app-sidebar" collapsed noIcons>
          <SidebarLayout.Sidebar>
            <SidebarLayout.Sidebar.Item />
          </SidebarLayout.Sidebar>
          <SidebarLayout.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={2} mWidth={0} />
                <Grid.Column width={8} mWidth={12}>
                  <Card>
                    <Card.Content className="flex-column-center">{children}</Card.Content>
                  </Card>
                </Grid.Column>
                <Grid.Column width={2} mWidth={0} />
              </Grid.Row>
            </Grid>
          </SidebarLayout.Content>
        </SidebarLayout>
        <AppFooter />
      </>
    );
  }
}

SLAContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SLAContainer;
